import { DataPoint } from "../fileParsing/types";
import { TimelineRangeType } from "@store/filters/types";
import * as d3 from "d3";

export const getMinMax = (data: DataPoint[]): TimelineRangeType => {
  const dates = d3.extent(data, (d) => d.date.getTime());
  if (dates[0] !== undefined && dates[1] !== undefined) return [new Date(dates[0]), new Date(dates[1])];

  return [undefined, undefined];
};
